import React from 'react';
import { Navigate } from 'react-router-dom';

const Root = (): JSX.Element => {
  return <Navigate to='/login' />;
};

export default Root;
